import React, { useState } from 'react';
import ReactPlayer from 'react-player/vimeo';
import './VideoGrid.css';
import thumbnail1 from './../../assets/Images/VideoGrid/1.png';
import thumbnail2 from './../../assets/Images/VideoGrid/2.png';
import thumbnail3 from './../../assets/Images/VideoGrid/3.png';
import thumbnail4 from './../../assets/Images/VideoGrid/4.png';

interface VideoItemProps {
  title: string;
  description: string;
  thumbnail: string;
  url: string;
}

const videos: VideoItemProps[] = [
  {
    title: 'Tolstoys Last Battle with Destiny',
    description: 'The artist and philosophical thinker—two essences of Leo Tolstoy',
    thumbnail: thumbnail1,
    url: 'https://vimeo.com/1071348722',
  },
  {
    title: 'Freemasons',
    description: 'Embak on an investigative journey into the enigmatic world of secret societies.',
    thumbnail: thumbnail2,
    url: 'https://vimeo.com/1071350177',
  },
  {
    title: 'Architecture of Happiness',
    description: 'How do buildings influence our emotions, identities, and daily lives?',
    thumbnail: thumbnail3,
    url: 'https://vimeo.com/1071351444',
  },
  {
    title: 'How Museums Transform Cities',
    description: 'Explore to what extent museums have the power to rejuvenate cities',
    thumbnail: thumbnail4,
    url: 'https://vimeo.com/1071352382',
  },
];


const VideoGrid: React.FC = () => {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

  return (
    <div className="video-grid-wrapper">
      <div className="video-grid">
        {/* Line 1 */}
        <div className="line-one">
          {videos.slice(0, 2).map((video, index) => (
            <div
              key={index}
              className={`video-card ${index === 0 ? 'wide' : 'narrow'}`}
              onClick={() => setSelectedVideo(video.url)}
            >
              <img src={video.thumbnail} alt={video.title} className="video-thumb" />
              <div className="video-overlay">
                <div className="play-icon">▶</div>
                <h3 className="video-title">{video.title}</h3>
                <p className="video-description">{video.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Line 2 */}
        <div className="line-two">
          {videos.slice(2, 4).map((video, index) => (
            <div
              key={index}
              className={`video-card ${index === 0 ? 'narrow' : 'wide'}`}
              onClick={() => setSelectedVideo(video.url)}
            >
              <img src={video.thumbnail} alt={video.title} className="video-thumb" />
              <div className="video-overlay">
                <div className="play-icon">▶</div>
                <h3 className="video-title">{video.title}</h3>
                <p className="video-description">{video.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedVideo && (
        <div className="video-popup">
          <div className="popup-content">
            <button className="close-btn" onClick={() => setSelectedVideo(null)}>
              ✕
            </button>
            <ReactPlayer url={selectedVideo} playing controls width="100%" height="100%" />
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoGrid;